import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Categorymaster } from 'src/app/shared/models/categorymaster.model';

import { environment } from '../../../environments/environment';

@Injectable({
	providedIn: 'root'
})

export class CategorymasterService {
	private apiUrl = environment.apiUrl;
	private apiUrl1 = environment.apiUrl1;

	constructor(private http: HttpClient) { }

	// getAll() {
	// 	return this.http.get<Categorymaster[]>(`${this.apiUrl}/api/categorymaster`);
	// }

	getAll() {
		return this.http.get<Categorymaster[]>(`${this.apiUrl1}api/master-types-data`);
	}

	getById(id: number) {
		return this.http.get(`${this.apiUrl1}/api/master-types-data/type/${id}`);
	}

	getByTypeId(Typeid: number) {
		return this.http.get(`${this.apiUrl1}/api/master-types-data/type/${Typeid}`);
	}

	getByTypeIdParentId(type:string , Typeid: number) {
		return this.http.get(`${this.apiUrl1}/api/master-types-data/getData/${type}/${Typeid}`);
	}

	create(categorymaster: any) {
		return this.http.post(`${this.apiUrl1}/api/master-types-data`, categorymaster);
	}

	update(categorymaster: Categorymaster) {
		return this.http.put(`${this.apiUrl}/api/categorymaster/${categorymaster.id}`, categorymaster);
	}

	delete(id: number) {
		return this.http.delete(`${this.apiUrl}/api/categorymaster/${id}`);
	}

	setActiveDeactiveUser(categorymaster: Categorymaster) {
		return this.http.put(`${this.apiUrl}/api/categorymaster/status-change/${categorymaster.id}`, categorymaster);
	}

	getByFormName(formName: string) {
		return this.http.get<any>(`${this.apiUrl}/categorymasters?form_name=${formName}`);
	}

	getAllTypes() {
		return this.http.get<any[]>(`${this.apiUrl1}/api/master-types`);
	}

	addType(payload: any) {
		return this.http.post<any>(`${this.apiUrl1}/api/master-types`, payload);
	}

	getOtherDetailData(detailsForId:any , detailsFor:any){
		return this.http.get(`${this.apiUrl1}/api/business-others-details/for/${detailsFor}/${detailsForId}`)
	}

	UpdateFactoryDetails(payload:any){
		return this.http.put(`${this.apiUrl1}/api/business-others-details` , payload)
	}

	PostFactoryDetails(payload:any){
		return this.http.post(`${this.apiUrl1}/api/business-others-details`, payload)
	}

	getStepperData(businessID: any){
		return this.http.get(`${this.apiUrl1}/api/auth/business-account/${businessID}`)
	}
}
